<template>
  <div class="sidebar-profile bg-white dark:bg-dark-900 shadow-md p-10">
    <div class="sidebar-profile-header">
      <div class="sidebar-profile-header-avatar flex justify-center">
        <div class="avatar bg-gray-300 rounded-full w-28 h-28">
          <UserCircleIcon class="w-full h-auto bg-light-100 dark:bg-dark-100 rounded-full" />
        </div>
      </div>
      <div class="sidebar-profile-name dark:text-white">
        <h4 class="mt-4 text-xl font-semibold text-center">{{ user.name }}</h4>
        <p class="text-center">{{ user.email }}</p>
      </div>
    </div>
    <hr class="my-5">
    <div class="sidebar-profile-body flex flex-col justify-start hover:text-color-2">
      <BackButton class="w-full" to_url="/dashboard" />
    </div>
  </div>
</template>

<script>
import { UserCircleIcon } from '@heroicons/vue/24/solid';
import BackButton from '@/components/buttons/BackButton.vue';

export default {
  name: 'SideBarProfile',
  components: { UserCircleIcon, BackButton },
  props: {
    user: Object
  }
}
</script>